var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImageView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 200,
    viewBox: "0 0 266 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 265,
    height: 199,
    rx: 3.5,
    fill: "#DAF9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 265,
    height: 199,
    rx: 3.5,
    stroke: "#91E0DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.833 93.3334C139.293 93.3334 139.667 92.9603 139.667 92.5C139.667 92.0398 139.293 91.6667 138.833 91.6667M138.833 93.3334C138.373 93.3334 138 92.9603 138 92.5C138 92.0398 138.373 91.6667 138.833 91.6667M138.833 93.3334V91.6667",
    stroke: "#0DB5B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.333 83.3333L149.667 116.667",
    stroke: "#0DB5B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.833 115.5C139.698 115.833 136.884 115.833 133 115.833C125.951 115.833 122.426 115.833 120.088 113.837C119.756 113.553 119.447 113.244 119.163 112.912C117.167 110.574 117.167 107.05 117.167 100C117.167 96.1162 117.167 93.3023 117.501 91.1672M146.393 113.393C146.547 113.238 146.695 113.078 146.837 112.912C148.833 110.574 148.833 107.05 148.833 100C148.833 92.9505 148.833 89.4257 146.837 87.088C146.553 86.756 146.244 86.4468 145.912 86.1633C143.574 84.1667 140.05 84.1667 133 84.1667C125.951 84.1667 122.426 84.1667 120.088 86.1633C119.922 86.3051 119.762 86.4532 119.608 86.6075",
    stroke: "#0DB5B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118 106.667L125.501 99.1674M148 106.667L143.884 102.551C143.318 101.985 142.55 101.667 141.75 101.667C140.95 101.667 140.182 101.985 139.616 102.551L137.583 104.583",
    stroke: "#0DB5B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageView);
export default __webpack_public_path__ + "static/media/no-image-view.b837ecf18cc0e3cf6220d89251b7ddfc.svg";
export { ForwardRef as ReactComponent };